import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        button: {
            backgroundColor: `${theme.palette.primary[700]} !important`,
            color: 'white !important',
            width: '22px !important',
            minWidth: '22px !important',
            height: '22px !important',
            borderRadius: 4,
        },
        icon: {
            width: '22px !important',
            height: '22px !important',
        },
    }
})

export default useStyles
